import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as feather from 'feather-icons';
import {FeatherIconNames} from 'feather-icons';

@Pipe({ name: 'feather', standalone: true })
export class FeatherPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(name: FeatherIconNames, attrs: Record<string, any> = {}): SafeHtml {
    const svg = feather.icons[name]?.toSvg(attrs) ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
